<template>
    <div style="width:100%;">
        <div class="editorContent">
            <input :disabled="ReadOnlyMode" type="text" v-if="param.style == 'Input'" :class="{interpolation: true}" v-model="CurrentValue.name" @change="ParameterText_Change($event)" />
            <input :disabled="ReadOnlyMode" type="date" v-else-if="param.style == 'Date' && (FormatDate(CurrentValue.key)==null || !FormatDate(CurrentValue.key).startsWith('{'))" :class="{interpolation: false}" :value="FormatDate(CurrentValue.key)" @change="ParameterDate_Change($event)" />
            <input :disabled="ReadOnlyMode" type="text" v-else-if="param.style == 'Date'" v-model="CurrentValue.name" @change="ParameterText_Change($event)" />
            <input :disabled="ReadOnlyMode" type="text" v-else-if="captionSearchResolved && (param.style == 'Tree' || useCaptionSearchPicker)" style="cursor: pointer" @click.stop="openMemberModal" v-model="CurrentValueLabel" readonly />
            <select :disabled="ReadOnlyMode" v-else-if="captionSearchResolved && param.style == 'List'" v-model="CurrentValue">
                <option v-if="IsUsingAReportBookParameter" v-bind:value="CurrentValue">{{CurrentValueLabel}}</option>
                <option v-for="choice, k in param.values" v-bind:value="choice">{{ValueLabel(choice)}}</option>
            </select>

            <div class="wbtn-array" v-if="ShowButtonArray && !ReadOnlyMode">
                <div class="wbtn"
                     style="padding: 5px;"
                     @click="PromoteParameter()"
                     :disabled="IsReportBookParameter || ReadOnlyMode">
                    <img src="../../../../public/icons/reportbook/promote_green.svg" />
                </div>
                <div class="wbtn" style="padding: 5px;"
                     @click="ReportBookParameterModal = true"
                     :disabled="IsReportBookParameter || ReadOnlyMode">
                    <img class="accent-svg" src="../../../../public/icons/reportbook/parameter.svg" />
                </div>
            </div>
        </div>

        <Modal v-if="TreeParameterModal" @close="TreeParameterModal = false" :size="useCaptionSearchPicker ? 'lg' : undefined">
            <template v-slot:header>
                <span class="modalTitle" :class="{memberPickerTitle: useCaptionSearchPicker}">{{param.label}}</span>
            </template>

            <template v-slot:body>
                <div :class="{memberWrapper: useCaptionSearchPicker}">
                    <div v-if="useCaptionSearchPicker" class="member-wrapper-inner">
                        <div class="memberSelectorToolbar">
                            <div class="toolbarItem">
                                <div style="grid-row: 1/1; display: grid; grid-template-columns: 25px auto 45px 35px 1px 50px; height: 30px; border: 1px solid var(--thin-border); border-radius:2px;">
                                    <div :title="Localizer.Localize('Search_PascalCase')" style="position:relative;top:-5px;">
                                        <img src="../../../../public/icons/models/search-10.svg" />
                                    </div>
                                    <input v-model="TreeSearchText" :placeholder="Localizer.Localize('DimensionMemberSelector_Member_Name')" :disabled="ReadOnlyMode" style="height:30px;border:none;background:none;outline:none;" />
                                    <div style="height: 28px;">
                                        <input v-if="HasTreeSearch && !CurrentlySearching"
                                               type="text"
                                               v-bind:disabled="true"
                                               style="max-width: fit-content; border-style: none; height: 28px;display:block;"
                                               :value="MatchCountText" />
                                        <div v-else-if="CurrentlySearching" class="loading"></div>
                                    </div>
                                    <div style="position:relative;top:-5px;">
                                        <img v-if="TreeSearchText"
                                             class="clearSearch theme-svg"
                                             src="../../../../public/icons/models/close.svg"
                                             :title="Localizer.Localize('Controls_Clear')"
                                             @click="clearMemberSearch" />
                                    </div>
                                    <div style="border-right: 1px solid var(--thin-border); height: 24px; margin-top: 2px;"></div>
                                    <div style="text-align: center; line-height: 25px;">
                                        <div :title="Localizer.Localize('DimensionMemberSelector_Move_To_Previous')" style="display:inline;" @click="moveToPreviousMatch"><img class="upArrow" src="../../../../public/icons/explorer/expander.svg" style="cursor:pointer;" /></div>
                                        <div :title="Localizer.Localize('DimensionMemberSelector_Move_To_Next')" style="display: inline; " @click="moveToNextMatch"><img class="downArrow" src="../../../../public/icons/explorer/expander.svg" style="cursor:pointer;" /></div>
                                    </div>
                                </div>
                            </div>
                            <div class="toolbarItem">
                                <div class="showSelection">
                                    <div style="padding-right: 10px; height: 30px; position: relative; top: -3px; ">
                                        {{Localizer.Localize('Show')}}
                                    </div>
                                    <select class="memberDisplaySelect" v-model="displayMode" :disabled="ReadOnlyMode" style="height: 30px; position: relative; border-radius: 2px; top: -1px;">
                                        <option value="nameAndCaption">{{Localizer.Localize('DimensionMemberSelector_Member_Name_And_Caption')}}</option>
                                        <option value="name">{{Localizer.Localize('DimensionMemberSelector_Member_Name_Only')}}</option>
                                        <option value="caption">{{Localizer.Localize('DimensionMemberSelector_Member_Caption_Only')}}</option>
                                    </select>
                                </div>
                                <label class="showOnlyMatches">
                                    <input type="checkbox" v-model="ShowOnlyMatches" :disabled="ReadOnlyMode" />
                                    {{Localizer.Localize('FormParameterEditor_ShowOnlyMatches')}}
                                </label>
                            </div>
                        </div>
                    </div>
                    <input v-else-if="SearchWFParametersFeatureFlagValue"
                           class="treeSearchInput"
                           type="text"
                           v-model="TreeSearchText"
                           :placeholder="Localizer.Localize('Search_PascalCase')" :disabled="ReadOnlyMode" />
                    <div :class="useCaptionSearchPicker ? ['showStriped', {noMatches: ShowNoMatchEmpty}] : 'modalContent'">
                        <Empty v-if="ShowNoMatchEmpty">{{ Localizer.Localize('FormParameterEditor_NoMatchingMembers') }}</Empty>
                        <transition-group v-else name="fso" tag="span">
                            <TreeParameterNode v-for="node, i in RootNodes"
                                               v-bind:key="key(i)"
                                               :Definition="node"
                                               :SearchText="TreeSearchTextForCurrentMode"
                                               :AutoExpand="AutoExpandMatches"
                                               :ShowOnlyMatches="ShowOnlyMatchesForNode"
                                               :MatchNameAndCaption="useCaptionSearchPicker"
                                               :DisplayMode="useCaptionSearchPicker ? displayMode : ''"
                                               :HighlightedKey="useCaptionSearchPicker ? HighlightedMemberKey : ''"
                                               :GridRows="useCaptionSearchPicker" />
                        </transition-group>
                    </div>
                </div>
            </template>

            <template v-slot:footer>
                <CommonButton
                    :type="ButtonType.Default"
                    :text="Localizer.Localize('Cancel_PascalCase')"
                    @click="TreeParameterModal = false"/>
                <CommonButton
                    :type="ButtonType.Primary"
                    :disabled="!CanChooseTreeParameterValue || ReadOnlyMode"
                    :text="Localizer.Localize('Ok_PascalCase')"
                    @click="ChooseTreeParameterValue()"/>
            </template>
        </Modal>

        <Modal v-if="ReportBookParameterModal" @close="CancelPickReportBookParameter">
            <template v-slot:header>
                <span class="modalTitle">Pick a report book parameter</span>
            </template>
            <template v-slot:body>
                <div>
                    <div class="modalContent"
                         v-if="ReportBookParameters === null || ReportBookParameters.length === 0">
                        <Empty>No report book parameters</Empty>
                    </div>
                    <div class="modalContent" v-else>
                        <transition-group name="fso" tag="span">
                            <div class="modalItemWrapper"
                                 v-for="(param, i) in ReportBookParameters"
                                 :class="{even: i%2==0}"
                                 :key="key(i)"
                                 @click="SelectReportBookParameter(param)"
                                 :style="{'--i':i/ReportBookParameters.length}">
                                <div class="modalItem">
                                    <span class="label">{{param.bookParameter.label}}</span>
                                </div>
                            </div>
                        </transition-group>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <CommonButton
                    :type="ButtonType.Default"
                    :text="Localizer.Localize('Cancel_PascalCase')"
                    @click="CancelPickReportBookParameter"/>
            </template>
        </Modal>
    </div>
</template>

<script lang="ts">
    require('@/assets/portal.css');

    import { Localizer } from "../../../api/Localizer";
    import { Component, Prop, Vue, Watch } from 'vue-facing-decorator';
    import * as api from "../../../api/ApiClient";
    import { TreeParameterNodeDefinition as NodeDefinition } from "../../../api/Extensions"
    import { isFeatureFlagEnabled } from "@/services/featureFlagService";

    import Modal from "../../helpers/Modal.vue";
    import Empty from "../../helpers/Empty.vue";
    import TreeParameterNode from "./TreeParameterNode.vue"
    import CommonButton from "../../helpers/CommonButton.vue";
    import { ButtonType } from "../../helpers/HelpersInterface";

    @Component({ components: { Modal, Empty, TreeParameterNode, CommonButton } })
    export default class FormParameterEditor extends Vue {
        @Prop() ReadOnlyMode: boolean = false;
        private Localizer = new Localizer(this.$store);
        private ButtonType = ButtonType;
        private searchWFParametersFlag: boolean = false;
        private captionSearchFlag: boolean = false;
        private captionSearchResolved = false;
        private ShowOnlyMatches = false;
        private displayMode: "name" | "caption" | "nameAndCaption" = "name";
        private matchIndex = 0;
        private CurrentlySearching = false;
        private searchTimeoutId: number | null = null;

        async mounted() {
            try {
                this.captionSearchFlag = await isFeatureFlagEnabled("FLUX-646_DimensionPickerCaptionSearch");
            } catch (error) {
                console.error("Error loading FLUX-646_DimensionPickerCaptionSearch feature flag:", error);
                this.captionSearchFlag = false;
            } finally {
                this.captionSearchResolved = true;
            }
            try {
                this.searchWFParametersFlag = await isFeatureFlagEnabled("FLUX-692_WorkflowParameterSearch");
            } catch (error) {
                console.error("Error loading FLUX-692_WorkflowParameterSearch feature flag:", error);
                this.searchWFParametersFlag = false;
            }
        }

        get SearchWFParametersFeatureFlagValue(): boolean { 
            return this.searchWFParametersFlag;
        }

        get useCaptionSearchPicker(): boolean {
            return this.captionSearchFlag && (this.param?.style === "Tree" || this.isDimensionMemberList);
        }

        private get isDimensionMemberList(): boolean {
            return this.param?.style === "List" && (this.param.values ?? []).some(value => value.isLeaf === true);
        }

        @Prop() private readonly param!: api.FormParameter;
        @Prop({default: null}) private readonly reportBookEntryPath!: string | null;

        private TreeParameterModal = false;
        private ReportBookParameterModal = false;
        private TreeSearchText = "";

        @Watch("TreeSearchText")
        onTreeSearchTextChanged() {
            this.matchIndex = 0;
            this.clearSearchTimeout();
            this.CurrentlySearching = this.useCaptionSearchPicker && this.HasTreeSearch;
            if (this.CurrentlySearching)
                this.searchTimeoutId = window.setTimeout(() => {
                    this.CurrentlySearching = false;
                    this.searchTimeoutId = null;
                }, 400);
        }

        private clearSearchTimeout() {
            if (this.searchTimeoutId !== null) {
                clearTimeout(this.searchTimeoutId);
                this.searchTimeoutId = null;
            }
        }

        beforeUnmount() {
            this.clearSearchTimeout();
        }

        get ShowButtonArray(): boolean {
            return this.reportBookEntryPath !== null;
        }

        beforeMount() {
            this.resetDisplayMode();
            if (!this.CurrentValue) {
                this.CurrentValue = new api.FormParameterValue();
            }
        }

        key(i: number): string {
            return i.toString();
        }

        get CurrentValue(): api.FormParameterValue | null | undefined {
            return this.param.currentValue;
        }
        set CurrentValue(val: api.FormParameterValue | null | undefined) {
            this.$emit("update", val);
        }

        ValueLabel(value: api.FormParameterValue | null | undefined): string {
            if (value) {
                if (this.Display == "Key")
                    return value.key!;
                else if (this.Display == "Name")
                    return value.name!;
                else if (this.Display == "Caption")
                    return value.caption!;
            }
            return "";
        }
        get Display(): string | null | undefined {
            return this.param.display;
        }
        get CurrentValueLabel(): string {
            if (this.useCaptionSearchPicker)
                return this.formatMemberLabel(this.CurrentValue);
            return this.ValueLabel(this.CurrentValue);
        }

        get SelectedTreeParameterValue(): api.FormParameterValue | null {
            return this.$store.state.forms.SelectedTreeParameterValue;
        }
        set SelectedTreeParameterValue(val: api.FormParameterValue | null) {
            this.$store.commit("forms/SetSelectedTreeParameterValue", val);
        }

        async ParameterText_Change(event: Event) {
            // For text input parameters, the inputed text is given to the key, name, and caption.
            var val = (event.target as HTMLInputElement).value;
            this.CurrentValue = new api.FormParameterValue({
                displayOnly: false,
                isLeaf: true,
                caption: val,
                key: val,
                name: val,
                parentKey: ""
            });
        }

        private FormatDate(dt: string) {
            if (dt == null)
                return null;
            if (dt.startsWith('{'))
                return dt;

            var str = dt.substr(0, 4) + "-" + dt.substr(4, 2) + "-" + dt.substr(6);
            console.log(str);
            return str;
        }

        async ParameterDate_Change(event: Event) {
            // For text input parameters, the inputed text is given to the key, name, and caption.
            var val = (event.target as HTMLInputElement).value;
            let yourDate = new Date(Date.parse(val));
            var dt = yourDate.toISOString().split('T')[0].replaceAll('-', '').replaceAll('/', '');
            console.log(dt);
            this.CurrentValue = new api.FormParameterValue({
                displayOnly: false,
                isLeaf: true,
                key: dt,
                parentKey: ""
            });
        }

        get SelectedTreeParameterNodes(): NodeDefinition[] | null {
            if (this.param && this.param.values) {
                var values = this.param.values;
                var nodes = values.map(val => new NodeDefinition(val, this.param.display));

                for (var node of nodes) {
                    var parentNode = nodes.find(n => n.Value.key == node.Value.parentKey);
                    if (parentNode) {
                        node.Parent = parentNode;
                        parentNode.Children.push(node);
                        parentNode.Value.isLeaf = false;
                    }
                }

                return nodes;
            }

            return null;
        }

        get RootNodes(): NodeDefinition[] | null {
            if (this.SelectedTreeParameterNodes)
                return this.SelectedTreeParameterNodes.filter(node => node.IsRoot);
            else
                return null;
        }

        get CanChooseTreeParameterValue(): boolean {
            return this.SelectedTreeParameterValue != null;
        }

        get HasTreeSearch(): boolean {
            return this.NormalizedTreeSearchText.length > 0;
        }

        get TreeSearchTextForCurrentMode(): string {
            if (this.useCaptionSearchPicker || this.SearchWFParametersFeatureFlagValue)
                return this.TreeSearchText;
            return "";
        }

        get AutoExpandMatches(): boolean {
            if (!this.HasTreeSearch)
                return false;
            return this.useCaptionSearchPicker || this.SearchWFParametersFeatureFlagValue;
        }

        get ShowOnlyMatchesForNode(): boolean {
            return this.useCaptionSearchPicker ? this.ShowOnlyMatches : true;
        }

        get ShowNoMatchEmpty(): boolean {
            if (!this.HasTreeSearch || this.HasTreeSearchResults)
                return false;
            if (this.useCaptionSearchPicker)
                return this.ShowOnlyMatches;
            return this.SearchWFParametersFeatureFlagValue;
        }

        get MatchingNodes(): NodeDefinition[] {
            if (!this.useCaptionSearchPicker || !this.HasTreeSearch)
                return [];
            const matches: NodeDefinition[] = [];
            this.collectMatchingNodes(this.RootNodes, this.NormalizedTreeSearchText, matches);
            return matches;
        }

        get HighlightedMemberKey(): string {
            const matches = this.MatchingNodes;
            if (matches.length === 0)
                return "";
            const index = Math.min(this.matchIndex, matches.length - 1);
            return matches[index].Value.key || "";
        }

        get MatchCountText(): string {
            const total = this.MatchingNodes.length;
            if (total === 0)
                return "0/0";
            const index = Math.min(this.matchIndex, total - 1);
            return `${index + 1}/${total}`;
        }

        get HasTreeSearchResults(): boolean {
            const roots = this.RootNodes;
            if (!roots || roots.length === 0) {
                return false;
            }

            if (!this.HasTreeSearch) {
                return true;
            }

            const searchText = this.NormalizedTreeSearchText;
            return roots.some(node => this.NodeMatchesSearch(node, searchText));
        }

        private get NormalizedTreeSearchText(): string {
            return this.TreeSearchText.trim().toLocaleLowerCase();
        }

        private NodeMatchesSearch(node: NodeDefinition, searchText: string): boolean {
            if (this.nodeSelfMatches(node, searchText))
                return true;
            return node.Children.some(child => this.NodeMatchesSearch(child, searchText));
        }

        private nodeSelfMatches(node: NodeDefinition, searchText: string): boolean {
            if (this.useCaptionSearchPicker) {
                const name = (node.Value.name || "").toLocaleLowerCase();
                const caption = (node.Value.caption || "").toLocaleLowerCase();
                return name.includes(searchText) || caption.includes(searchText);
            }
            return (node.Label || "").toLocaleLowerCase().includes(searchText);
        }

        private collectMatchingNodes(nodes: NodeDefinition[] | null, searchText: string, matches: NodeDefinition[]) {
            if (!nodes)
                return;
            for (const node of nodes) {
                if (this.nodeSelfMatches(node, searchText))
                    matches.push(node);
                this.collectMatchingNodes(node.Children, searchText, matches);
            }
        }

        private formatMemberLabel(value: api.FormParameterValue | null | undefined): string {
            if (!value)
                return "";
            const name = value.name || "";
            const caption = value.caption || "";
            if (this.displayMode === "name")
                return name;
            if (this.displayMode === "caption")
                return caption;
            if (!name)
                return caption;
            if (!caption)
                return name;
            return `${name} - ${caption}`;
        }

        private resetDisplayMode() {
            if (this.param?.display === "Caption")
                this.displayMode = "caption";
            else if (this.param?.display === "Name")
                this.displayMode = "name";
            else
                this.displayMode = "nameAndCaption";
        }

        openMemberModal() {
            this.SelectedTreeParameterValue = null;
            this.TreeSearchText = "";
            this.ShowOnlyMatches = false;
            this.matchIndex = 0;
            this.TreeParameterModal = true;
        }

        clearMemberSearch() {
            this.TreeSearchText = "";
            this.matchIndex = 0;
        }

        moveToNextMatch() {
            const total = this.MatchingNodes.length;
            if (total === 0)
                return;
            const current = Math.min(this.matchIndex, total - 1);
            this.matchIndex = (current + 1) % total;
        }

        moveToPreviousMatch() {
            const total = this.MatchingNodes.length;
            if (total === 0)
                return;
            const current = Math.min(this.matchIndex, total - 1);
            this.matchIndex = (current - 1 + total) % total;
        }

        async ChooseTreeParameterValue() {
            this.CurrentValue = this.SelectedTreeParameterValue;
            this.TreeParameterModal = false;
        }

        get OldReportBookParameters(): api.BookAndFormParameter[] | null {
            return this.$store.getters["reportbook/ReportBookParameters"];
        }
        get NewReportBookParameters(): api.BookAndFormParameter[] {
            return this.$store.state.reportbook.NewReportBookParameters;
        }
        get ReportBookParameters(): api.BookAndFormParameter[] {
            return (this.OldReportBookParameters ? this.OldReportBookParameters : []).concat(this.NewReportBookParameters);
        }
        get FormSpecificReportBookParameters(): api.BookAndFormParameter[] {
            return (this.OldReportBookParameters ? this.OldReportBookParameters.filter(p => p.bookParameter!.sourcePath === this.reportBookEntryPath) : []).concat(this.NewReportBookParameters);
        }

        get IsInListOfReportBookParameters(): boolean {
            return this.FormSpecificReportBookParameters.some(p => p.bookParameter!.sourceName === this.param.name);
        }
        get FollowsNamingConvention(): boolean {
            return this.$store.getters["reportbook/FollowsReportBookParameterNamingConvention"](this.param);
        }
        get IsReportBookParameter(): boolean {
            return this.IsInListOfReportBookParameters && this.FollowsNamingConvention;
        }

        get IsUsingAReportBookParameter(): boolean {
            return this.CurrentValue!.name ? this.CurrentValue!.name.startsWith("{BookParameter.") && this.CurrentValue!.name.endsWith(".Key}") : false;
        }

        async PromoteParameter() {
            // if this parameter has been promoted in the past, assign it here
            var formParameterName = this.param.name!;
            var existingRbParameter = this.FormSpecificReportBookParameters.find(p => p.bookParameter!.sourceName === formParameterName);
            var rbParameterName: string;

            if (existingRbParameter) {
                rbParameterName = existingRbParameter.bookParameter!.name!;
            }
            else {
                rbParameterName = await this.AssignReportBookParameterName(formParameterName);
                this.NewReportBookParameters.push(new api.BookAndFormParameter({
                    bookParameter: new api.BookParameter({
                        name: rbParameterName,
                        label: this.param.label ? this.param.label : rbParameterName,
                        sourcePath: this.reportBookEntryPath!,
                        sourceName: this.param.name!
                    }),
                    formParameter: this.param
                }));
            }
            this.CurrentValue = this.$store.getters["reportbook/ReportBookParameterValue"](rbParameterName);
        }

        async AssignReportBookParameterName(name: string): Promise<string> {
            var testName = name;
            var counter = 0;
            while (this.ReportBookParameters!.some(p => p.bookParameter!.name === testName)) {
                testName = name + counter;
                counter++;
            }
            while (this.NewReportBookParameters.some(p => p.bookParameter!.name === testName)) {
                testName = name + counter;
                counter++;
            }
            return testName;
        }

        async CancelPickReportBookParameter() {
            this.ReportBookParameterModal = false;
        }
        async SelectReportBookParameter(param: api.BookAndFormParameter) {
            this.CurrentValue = this.$store.getters["reportbook/ReportBookParameterValue"](param.bookParameter!.name!);
            this.CancelPickReportBookParameter();
        }
    }
</script>

<style scoped>
    input, select, textarea {
        border: 1px solid var(--thin-border);
        border-radius: 3px 3px;
        padding: 5px;
        width: 100%;
    }

        input[type='checkbox'] {
            width: auto;
            margin-left: 10px;
            margin-top: 10px;
        }

    .editorContent {
        display: grid;
        grid-template-columns: 1fr auto;
        grid-column-gap: 5px;
    }

    .buttonArray {
        position: relative;
        top: 50%;
        transform: translateY(-100%);
    }

        .buttonArray button {
            border: none;
            background: none;
            position: relative;
            top: 50%;
        }

            .buttonArray button[disabled] {
                opacity: 0.5;
            }

    .modalTitle {
        font-size: 22px;
        font-weight: bold;
    }

        .modalTitle.memberPickerTitle {
            font-size: 14px;
            color: #555;
            vertical-align: top;
            display: inline-block;
            line-height: 24px;
        }

    .modalContent {
        grid-column: auto;
        overflow-y: auto;
        background-color: var(--background-primary);
        border: 1px solid var(--thin-border);
        overflow-x: auto;
        overflow-y: auto;
        height: 300px;
    }

    .treeSearchInput {
        margin-bottom: 10px;
        box-sizing: border-box;
    }

    .memberWrapper {
        line-height: 36px;
        border: 1px solid var(--thin-border);
        border-radius: 2px;
        background: var(--background-primary);
    }

    .showStriped {
        background: repeating-linear-gradient(var(--background-primary), var(--background-primary) 41px, var(--thin-border) 41px, var(--thin-border) 42px, #fcfcfc 42px, #fcfcfc 83px, var(--thin-border) 83px, var(--thin-border) 84px);
        background-attachment: local;
        overflow: auto;
        overflow-anchor: none;
        border-top: 1px solid var(--thin-border);
        height: 300px;
    }

        .showStriped.noMatches {
            background: var(--background-primary);
        }

    .memberSelectorToolbar {
        background: var(--background-primary);
        display: table;
        width: 100%;
        border-collapse: separate;
        border-spacing: 1em;
    }

    .clearSearch {
        cursor: pointer;
        height: 17px;
    }

    .loading {
        position: relative;
        width: 24px;
        height: 24px;
        margin-left: 3px;
        display: inline-block;
        vertical-align: middle;
    }

        .loading::after {
            content: "";
            position: absolute;
            width: 16px;
            height: 16px;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            border: 4px solid transparent;
            border-top-color: var(--theme-svg);
            border-radius: 50%;
            animation: loading-spinner 1s ease infinite;
        }

    @keyframes loading-spinner {
        from {
            transform: rotate(0turn);
        }

        to {
            transform: rotate(1turn);
        }
    }

    .upArrow {
        transform: rotate(-90deg);
        filter: var(--theme-svg);
    }

    .downArrow {
        transform: rotate(90deg);
        filter: var(--theme-svg);
    }

    .toolbarItem {
        display: table-cell;
    }

    .showSelection {
        display: grid;
        grid-template-columns: auto auto;
        height: 30px;
    }
    .showOnlyMatches {
        display: flex;
        align-items: center;
        gap: 6px;
        line-height: 20px;
        white-space: nowrap;
        font-weight: normal !important;
        justify-content: end;
        padding-top: 10px;
    }

        .showOnlyMatches input {
            margin: 0;
        }

    .modalItemWrapper {
        width: 100%;
        border-bottom: 1px solid var(--thin-border);
        padding-bottom: 0px;
        cursor: pointer;
        user-select: none;
        padding-top: 5px;
        padding-bottom: 5px;
        line-height: 28px;
        height: 36px;
        position: relative;
        white-space: nowrap;
    }

        .modalItemWrapper.even {
            background-color: var(--background-even);
        }

    .modalItem .label {
        overflow: hidden;
        position: absolute;
        left: 56px;
        right: 28px;
        text-overflow: ellipsis;
    }

</style>
